import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { DirtyComponent } from "../models/dirty-component";
import { ConfirmLeaveComponent } from "../shared/dialogs/confirm-leave/confirm-leave.component";

import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";

@Injectable({
  providedIn: "root",
})
export class DirtyCheckGuard  {
  constructor(public dialog: MatDialog) {}
  openDialog() {
    let dialogRef = this.dialog.open(ConfirmLeaveComponent, {
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        return true;
      } else {
        return false;
      }
    });
    return dialogRef.afterClosed();
  }

  canDeactivate(
    component: DirtyComponent,
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (component.canDeactivate()) {
      // return confirm(
      //   'There are changes you have made to the page. If you quit, you will lose your changes.'
      // );
      return this.openDialog();
    } else {
      return true;
    }
  }
}
